import { render } from "./SuccessMessagePanel.vue?vue&type=template&id=70db73b6&scoped=true"
const script = {}

import "./SuccessMessagePanel.vue?vue&type=style&index=0&id=70db73b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70db73b6"]])

export default __exports__